import { TableCell } from "@mui/material";
import React, { FC } from "react";
import { UserRole } from "../../../common/enums/common.enums";
import { rowCellStyle } from "../DashboardTable/TableHeading/TableHeading.styles";
import "./RoleTableCell.scss";
const RoleTableCell: FC<{ role: string }> = ({ role }) => {
  return (
    <TableCell style={rowCellStyle}>
      <div className="role-table-cell">{role}</div>
    </TableCell>
  );
};

export default RoleTableCell;
